import type * as React from 'react';

import type { InlineProps } from '@gitbook/slate-react';
import { Emoji } from '@gitbook/spine-react';

import { getBasicBlockFontSize } from './BasicBlockWrapper';

/*
 * Basic renderer for an inline emoji
 */
export function BasicInlineEmoji(props: InlineProps): React.ReactElement {
    const { node, parent, attributes } = props;

    const emojiCode = node.data.get('code');
    const size = getBasicBlockFontSize(parent.object === 'block' ? parent : null);

    return (
        <span className="inline-flex align-middle" {...attributes}>
            <Emoji code={emojiCode} size={size} />
        </span>
    );
}
